import React from 'react';
import './LandingPageComponent.css';

const LandingPageComponent: React.FC = () => {
  return (
    <div className="landing">

      {/* Hero */}
      <section className="hero">
        <div className="hero-inner">
          <div className="hero-badge">
            <span className="material-symbols-outlined badge-icon">auto_awesome</span>
            AI-Powered Medical Training
          </div>
          <h1 className="hero-heading">
            Master Medical<br />
            <span className="hero-heading-accent">Diagnosis</span> Through<br />
            AI Challenges
          </h1>
          <p className="hero-body">
            Test your diagnostic skills with AI-generated medical mystery cases.
            Read patient stories, analyze symptoms, and deliver the correct diagnosis or treatment.
          </p>
          <div className="hero-actions">
            <a href="#download" className="btn-primary">
              Start Playing Free
            </a>
            <a href="#features" className="btn-ghost">
              See How It Works
            </a>
          </div>
        </div>

        <div className="hero-glow" />
        <div className="hero-noise" />
      </section>

      {/* Stats */}
      <div className="stats-bar">
        <div className="stats-inner">
          <div className="stat">
            <span className="stat-number">∞</span>
            <span className="stat-label">AI-Generated Cases</span>
          </div>
          <div className="stat-divider" />
          <div className="stat">
            <span className="stat-number">2</span>
            <span className="stat-label">Game Modes</span>
          </div>
          <div className="stat-divider" />
          <div className="stat">
            <span className="stat-number">100%</span>
            <span className="stat-label">Free to Play</span>
          </div>
          <div className="stat-divider" />
          <div className="stat">
            <span className="stat-number">iOS & Android</span>
            <span className="stat-label">Cross-Platform</span>
          </div>
        </div>
      </div>

      {/* Features */}
      <section className="features" id="features">
        <div className="section-inner">
          <div className="section-header">
            <p className="section-eyebrow">Why Medi Mystery?</p>
            <h2 className="section-heading">Challenge Your Medical Knowledge</h2>
            <p className="section-subheading">
              AI-generated cases that adapt to your skill level. Learn, compete, and become a diagnostic master.
            </p>
          </div>

          <div className="feature-grid">
            <div className="feature-card">
              <div className="feature-card-top">
                <div className="feature-number">01</div>
                <div className="feature-icon-wrap">
                  <span className="material-symbols-outlined">smart_toy</span>
                </div>
              </div>
              <h3 className="feature-title">Endless Generated Challenges</h3>
              <p className="feature-body">
                Every case is uniquely crafted by advanced AI, creating realistic medical scenarios
                that test your diagnostic reasoning and clinical knowledge.
              </p>
            </div>

            <div className="feature-card feature-card--highlight">
              <div className="feature-card-top">
                <div className="feature-number">02</div>
                <div className="feature-icon-wrap">
                  <span className="material-symbols-outlined">local_fire_department</span>
                </div>
              </div>
              <h3 className="feature-title">Diagnosis & Treatment</h3>
              <p className="feature-body">
                Test both your diagnosis and treatment skills — with lots more coming soon, including an Emergency Room mode.
              </p>
              <div className="feature-badge">Coming Soon: ER Mode</div>
            </div>

            <div className="feature-card">
              <div className="feature-card-top">
                <div className="feature-number">03</div>
                <div className="feature-icon-wrap">
                  <span className="material-symbols-outlined">school</span>
                </div>
              </div>
              <h3 className="feature-title">Educational & Fun</h3>
              <p className="feature-body">
                Learn real medical concepts while having fun. Each challenge includes detailed
                explanations and references to help you understand the diagnosis.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Download CTA */}
      <section className="cta" id="download">
        <div className="cta-glow" />
        <div className="section-inner cta-inner">
          <p className="section-eyebrow">Available Now</p>
          <h2 className="section-heading">Ready to Test Your Skills?</h2>
          <p className="section-subheading">Download free on iOS and Android. Play anywhere, anytime.</p>

          <div className="store-buttons">
            <a
              href="https://play.google.com/store/apps/details?id=com.medimystery"
              className="store-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="material-symbols-outlined store-btn-icon">android</span>
              <span className="store-btn-text">
                <span className="store-btn-sub">Get it on</span>
                <span className="store-btn-name">Google Play</span>
              </span>
            </a>

            <a
              href="https://apps.apple.com/app/medi-mystery/id1234567890"
              className="store-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg className="store-btn-icon store-btn-apple" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  fill="currentColor"
                  d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"
                />
              </svg>
              <span className="store-btn-text">
                <span className="store-btn-sub">Download on the</span>
                <span className="store-btn-name">App Store</span>
              </span>
            </a>
          </div>
        </div>
      </section>

    </div>
  );
};

export default LandingPageComponent;
